module.exports = __webpack_public_path__ + "img/student.d871e984.svg";